// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e63984d7","186":"cd26c586","344":"c6dffc87","372":"11eaf118","377":"cd5cf1d2","448":"1008f903","738":"d1c49ce6","841":"5966bd48","856":"1103797b","886":"55ba6ba5"}[chunkId] + ".chunk.js";
};